import { api as generatedApi } from "./api.generated";

export const api = generatedApi
  .injectEndpoints({
    endpoints: (build) => ({}),
  })
  .enhanceEndpoints({
    addTagTypes: ["convertedFiles"],
    endpoints: {
      getApiConvertedFiles: {
        providesTags: ["convertedFiles"],
      },
      postApiConvertTusFile: {
        invalidatesTags: ["convertedFiles"],
      },
    },
  });


export const { useLazyGetApiUploadedFilesQuery } = api;


